export const emailValidate = (email?: string): string | undefined => {
  if (!email) {
    return "Email is required";
  }

  if (typeof email !== "string") {
    return "Invalid email format";
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(email)) {
    return "Invalid email!";
  }
};

export const passwordValidate = (password?: string): string | undefined => {
  if (!password) {
    return "Password is required";
  }

  if (password.length < 8) {
    return "Password must be at least 8 characters";
  }

  if (!/\d/.test(password)) {
    return "Password must contain at least one number";
  }

  if (!/[A-Z]/.test(password)) {
    return "Password must contain at least one uppercase letter";
  }

  if (!/[a-z]/.test(password)) {
    return "Password must contain at least one lowercase letter";
  }

  if (!/[^a-zA-Z0-9]/.test(password)) {
    return "Password must contain at least one non-alphanumeric character";
  }
};

export const phoneNumberValidate = (phone?: string): string | undefined => {
  const phoneNumber = phone?.split("-")[1];
  if (!phoneNumber || phoneNumber.trim() === "") {
    return "Phone number is required";
  }

  if (!/^\d+$/.test(phoneNumber)) {
    return "Phone number should contain only digits.";
  }

  if (phoneNumber.length !== 10) {
    return "Invalid phone number";
  }
};
